import { render, staticRenderFns } from "./ActionDetail.vue?vue&type=template&id=b2c12d9c&scoped=true&"
import script from "./ActionDetail.vue?vue&type=script&lang=js&"
export * from "./ActionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c12d9c",
  null
  
)

export default component.exports